var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.loaded)?_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[(_vm.isLoaded)?_c('router-view'):_c('ErrorAlerta',{attrs:{"showBtn":_vm.errorConfig.showBtn,"texto":_vm.errorConfig.texto,"titulo":_vm.errorConfig.titulo}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }